module.exports = __webpack_public_path__ + "static/media/modelC_cmp1.8b7109e5.gif";